import { numberToPrettyString } from '@cian/utils';
import { getCurrencySign } from './getCurrencySign';
import { IOfferCard } from '../../../types';

export function getDepositPrice({ bargainTerms: { deposit, currency } }: IOfferCard): string {
  if (deposit) {
    const price = numberToPrettyString(deposit);

    if (currency === 'rur') {
      return `залог ${price}\u00A0₽`;
    } else {
      return `залог ${getCurrencySign(currency)}${price}`;
    }
  }

  return 'без залога';
}
